// Import Packages
import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { ObjectInspector, chromeLight } from 'react-inspector';
import { useSetRecoilState, useRecoilValue } from 'recoil';

// Import Material UI
import { makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import { Chip, IconButton, TextField, Dialog } from '@material-ui/core';
import Autocomplete from '@material-ui/lab/Autocomplete';
import AddCircleOutlineIcon from '@material-ui/icons/AddCircleOutline';

// Import Recoil
import { alertState } from '../../../../../recoil-store/recoil-state';

// Import Icons
import CloseIcon from '../../../../../assets/icons/close-icon.svg';
import PassiveRadioIcon from '../../../../../assets/icons/passive-radio-icon.svg';
import ActiveRadioIcon from '../../../../../assets/icons/active-radio-icon.svg';
import BluePlusIcon from '../../../../../assets/icons/blue-plus-icon';

// Import Pages

import { VariableModal } from '../../../../FlowConfigurationInputs/VariableModal/VariableModal';

const useStyles = makeStyles(theme => ({
    dialogContainer: {
        display: 'flex',
        justifyContent: 'space-between',
        background: '#FFFFFF',
        overflowY: "visible",
        width: "360px",
        left: "20%"
    },
    dialogPaper: {
        boxShadow: 'none', // Kutu gölgesini kaldır
        backgroundColor: 'transparent', // Arkaplanı şeffaf yap
    },
    option: {
        '& > span': {
            marginRight: 10,
            fontSize: 12,
        },
        fontSize: 13,
        fontWeight: 600,
        color: '#46474E',
    },
    inputRoot: {
        "& fieldset": {
            borderColor: '#E6E6E6',
            borderWidth: '1.1px'
        }
    },
    popupIndicator: {
        color: "#B0B0B0",
        height: "10px",
        width: "10px"
    }
}));

const variableRegex = /(##[\w-]+(\[[-\w\s]+\])*##)/g;


/**
 * @Description This function lets you return component according to the name of the incoming action.
 * @Param       action - object
 * @Param       variables - object variable list
 * @Param       setOpenVariable - open variable function that allows us to open
 * @Returns     Component
 * @Author      Abdullah Onur Yeşil
 */
function Assign({ action, variables, setOpenVariable, variableRender, automDetail, actions, assignData, save, cancel }) {
    const [assignType, setAssignType] = useState("available");
    const [chips, setChips] = useState([]);
    const [open, setOpen] = useState(false);
    const [dropdownValue, setDropdownValue] = useState({});
    const [indexValue, setIndexValue] = useState(0);
    const setAlert = useSetRecoilState(alertState);

    const label = "CONTENT.CONFIGURATION-FORM.ADVANCED-ACTIONS.DATA-TRANSFORM.";

    const { t } = useTranslation();
    const classes = useStyles();
    // Assign to Different Variable

    const saveAssign = () => {
        if (assignType === "different" && chips.length === 0) {
            setAlert(alert => ({
                ...alert,
                show: true,
                message: t(label + 'DIFFERENT-VARIABLE-REQUIRED'),
                severity: 'error'
            }))
            return;
        }
        save(assignType, chips);
    }

    const handleChange = (e, newValue) => {
        if (e.key && e.key === "Enter") {
            if (e.target.value) {
                if (!variableRegex.test(e.target.value)) {
                    return;
                }
            }
        }
        setChips(newValue);
    }

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleAddClick = async () => {
        let text
        if (dropdownValue.type === 'array' && indexValue !== null) {
            text = '##' + dropdownValue.name + '[' + indexValue + ']##';
        } else {
            text = '##' + dropdownValue.name + '##'
        }
        setChips([...chips, text]);
        setOpen(false);
    };

    return (
        <Dialog open={true} className='base-dialog-content' PaperProps={{ className: classes.dialogContainer }}>
            <div className='assign-modal-container'>

                <div className='items-center-between'>
                    <div className='base-modal-title base-title-detail'>
                        {t(label + "ASSIGN-TO-VARIABLE")}
                    </div>
                    <img className='transform-cancel-icon' src={CloseIcon} onClick={cancel} />

                </div>
                <div className='radio-buttons-container'>
                    <div className='just-display-flex'>
                        <img className='transform-radio-icon' src={assignType === 'different' ? ActiveRadioIcon : PassiveRadioIcon}
                            onClick={() => setAssignType('different')} />
                        <div className={`assign-radio-text ${assignType === 'different' ? "active" : "passive"}`}>{t(label + "ASSIGN-TO-DIFFERENT-VARIABLE")}</div>
                    </div>
                    {
                        assignType === "different" &&
                        <div className='m-t-12'>
                            <div className='items-center'>
                                <Autocomplete
                                    classes={{
                                        option: classes.option,
                                        inputRoot: classes.inputRoot,
                                        popupIndicator: classes.popupIndicator
                                    }}
                                    style={{ width: "90%", position: 'relative', background: '#FBFBFB' }}
                                    freeSolo
                                    multiple
                                    onChange={handleChange}
                                    value={chips}
                                    size="small"
                                    options={[]}
                                    disableCloseOnSelect
                                    getOptionLabel={(option) => option}
                                    renderInput={params => <TextField {...params} variant="outlined" />}
                                />

                                <IconButton className="add-variable-button" onClick={handleClickOpen}>
                                    <AddCircleOutlineIcon className="add-variable-icon" />
                                </IconButton>
                                {open && (
                                    <VariableModal setOpen={setOpen} variables={variables}
                                        dropdownValue={dropdownValue} setDropdownValue={setDropdownValue}
                                        setOpenVariable={setOpenVariable}
                                        indexValue={indexValue} setIndexValue={setIndexValue}
                                        handleAddClick={handleAddClick}
                                    />
                                )}
                            </div>
                            <small className='conf-field-desc'><em>{t(label + "ASSIGN-FORMAT-DESC")}</em></small>

                        </div>



                        // <TextField
                        //     multiline
                        //     label="Text Alanı"
                        //     value={inputText}
                        //     onChange={handleInputChange}
                        //     onKeyDown={handleInputKeyDown}
                        //     fullWidth
                        //     InputProps={{
                        //         startAdornment: (
                        //             <InputAdornment position="start">
                        //                 {chips.map((chip, index) => (
                        //                     <Chip
                        //                         key={index}
                        //                         label={chip}
                        //                         onDelete={handleChipDelete(chip)}
                        //                         style={{ margin: '2px' }}
                        //                     />
                        //                 ))}
                        //             </InputAdornment>
                        //         ),
                        //     }}
                        // />
                        // <div className='m-t-8'>
                        //     <TextInput
                        //         className="custimize-text-area"
                        //         action={firstValue}
                        //         variables={variables}
                        //         setOpenVariable={setOpenVariable}
                        //         isRequired={false}
                        //         ignoreSave={true}
                        //         setField={changeFirstValue}
                        //     />
                        // </div>
                    }

                    <div className='just-display-flex m-t-12'>
                        <img className='transform-radio-icon' src={assignType === 'available' ? ActiveRadioIcon : PassiveRadioIcon}
                            onClick={() => setAssignType('available')} />
                        <div className={`assign-radio-text ${assignType === 'available' ? "active" : "passive"}`}>{t(label + "UPDATE-VARIABLE")}</div>
                    </div>
                </div>


                <div className='configuration-footer'>
                    <Button className='transform-submit-button' onClick={saveAssign}>
                        {t(label + 'CONTINUE-DATA-TRANSFORM')}
                    </Button>
                </div>
            </div>

        </Dialog>
    )
}


export default Assign;